import styled from "styled-components";

// Form Container
export const FormContainer = styled.div`
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    padding: 16px;
    margin-bottom: 24px;
    border: 1px solid #f0f0f0;
`;

export const FormTitle = styled.h3`
    margin-bottom: 12px;
    font-weight: 700;
    font-size: 20px;
    padding-bottom: 6px;
    letter-spacing: 0.2px;
    color: #333;
`;

// General Info Section
export const GeneralInfoSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 16px;
`;

export const InfoRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const InfoLabel = styled.span`
    font-weight: 600;
    color: #444;
    min-width: 130px;
    font-size: 13px;
`;

// Fee Type Cards
export const FeeTypesContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 16px;
`;

export const FeeTypeCard = styled.div`
    background-color: #fafafa;
    border: 1.5px solid #d4d4d4;
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.15);
    }
`;

export const FeeTypeHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 2px solid #aef001;
`;

export const FeeTypeTitle = styled.h4`
    font-size: 15px;
    font-weight: 600;
    color: #333;
    margin: 0;
`;

export const FeeTypeBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

// Form Items
export const FormItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
`;

export const FormLabel = styled.label`
    font-weight: 600;
    color: #333;
    font-size: 11px;
`;

export const CompactFormItem = styled.div`
    display: flex;
    align-items: center;
    gap: 3px;
    min-width: 0;
    flex-shrink: 0;
`;

export const CompactLabel = styled.label`
    font-weight: 500;
    color: #666;
    font-size: 10px;
    white-space: nowrap;
    min-width: fit-content;
`;

export const FormInputRow = styled.div`
    display: flex;
    gap: 6px;
    align-items: flex-start;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

// Custom Time Section
export const CustomTimeSection = styled.div`
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #e8e8e8;
`;

export const CustomTimeHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
`;

export const CustomTimeTitle = styled.span`
    font-weight: 600;
    font-size: 13px;
    color: #333;
`;

export const CustomTimeList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 6px;
`;

export const CustomTimeItem = styled.div`
    background-color: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    padding: 5px 6px;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
    flex-wrap: nowrap;

    &:hover {
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    }
`;

export const CustomTimeItemIndex = styled.div`
    font-weight: 600;
    font-size: 11px;
    color: #666;
    background: #f5f5f5;
    min-width: 30px;
    height: 30px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const CustomTimeItemBody = styled.div`
    display: flex;
    align-items: center;
    gap: 18px;
    flex: 1;
    min-width: 0;
    flex-wrap: wrap;
`;

export const CustomTimeItemActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 0;
`;

// Action Buttons
export const ActionButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    padding-top: 12px;
    border-top: 1px solid #e8e8e8;
`;

// Header action buttons (recalculate / upload)
export const HeaderActions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 8px;

    .ant-btn {
        width: 280px;
        margin-right: 0;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        width: 100%;
        margin-bottom: 16px;

        .ant-upload,
        .ant-badge {
            width: 100%;
        }

        .ant-btn {
            width: 100%;
        }
    }
`;

// Note Section
export const NoteSection = styled.div`
    color: #888;
    margin-top: 10px;
    font-size: 12px;
    font-style: italic;
`;

// Helper Components
export const AddButton = styled.div`
    cursor: pointer;
    color: #388e3c;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 3px;
    padding: 5px 8px;
    border: 1px dashed #388e3c;
    border-radius: 6px;
    background-color: #fff;
    transition: all 0.2s;

    &:hover {
        color: #43a047;
        border-color: #43a047;
        background-color: #f1f8f4;
    }
`;

export const RemoveButton = styled.div`
    cursor: pointer;
    color: #b71c1c;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: 1px solid #b71c1c;
    border-radius: 4px;
    background-color: #fff;
    transition: all 0.2s;

    &:hover {
        color: #fff;
        background-color: #b71c1c;
    }
`;
